export const messages = {
  en: {
    notice: {
      title: 'Title',
      queryConditions: 'Query Conditions',
      noticeInfo: 'Notice Information',
      publish: 'Publish',
      query: 'Query',
      newNotice: 'New Notice',
      editNotice: 'Edit Notice',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
      noticeTitle: 'Notice Title',
      noticeType: 'Notice Type',
      noticeId: 'Notice ID',
      startTime: 'Start Time',
      endTime: 'End Time',
      noticeContent: 'Notice Content',
      noticeScope: 'Notice Scope',
      operation: 'Operation',
      detail: 'Detail',
      edit: 'Edit',
      delete: 'Delete',
      pleaseSelect: 'Please Select',
      pleaseInput: 'Please Input',
      building: 'Building',
      unit: 'Unit',
      room: 'Room',
      ownerNotice: 'Owner Notice',
      staffNotice: 'Staff Notice',
      ownerWechatNotice: 'Owner Wechat Notice',
      status: 'Status',
      coverage: 'Coverage',
      confirmDeleteNotice: 'Are you sure to delete this notice?'
    }
  },
  zh: {
    notice: {
      title: '标题',
      queryConditions: '查询条件',
      noticeInfo: '公告信息',
      publish: '发布',
      query: '查询',
      newNotice: '新公告',
      editNotice: '修改公告',
      confirmDelete: '确认删除',
      cancel: '取消',
      confirm: '确定',
      noticeTitle: '公告标题',
      noticeType: '公告类型',
      noticeId: '公告ID',
      startTime: '开始时间',
      endTime: '结束时间',
      noticeContent: '公告内容',
      noticeScope: '公告范围',
      operation: '操作',
      detail: '详情',
      edit: '修改',
      delete: '删除',
      pleaseSelect: '请选择',
      pleaseInput: '请输入',
      building: '楼栋',
      unit: '单元',
      room: '房屋',
      ownerNotice: '业主通知',
      staffNotice: '员工通知',
      ownerWechatNotice: '业主微信通知',
      status: '状态',
      coverage: '通知范围',
      confirmDeleteNotice: '确定删除该公告吗？'
    }
  }
}